import React from "react";
import Slider from "react-slick";
import { useTSContext } from "../../../context/Dashboard/contextTScore";
import { useThemeMode } from "../../../context/contextTheme";
import "./style.css";

const CVulMisCarousel = ({ score }) => {
  const { theme } = useThemeMode();
  const {
    hasAssets,
    hasMisconfig,
    cloudCriticalScore
  } = useTSContext();

  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    swipe: true,
  };

  return (
    <>
      <div className="p-2 pb-0 mb-3">
        <div
          className="card critical-vul-mis shadow-sm rounded-4"
          style={{
            width: 260,
            height: 180,
            backgroundColor: theme.labelBgDanger,
            border: `1px solid ${theme.border}`,
          }}
        >
          <Slider {...sliderSettings}>
            {/* Slide 1: Critical Vulnerabilities */}
            <div>
              <div className="card-body text-center">
                <div className="mb-2">
                  <h4 className="fw-bold" style={{ fontSize: 28, color: theme.labelTextDanger }}>
                    Critical
                  </h4>
                  <h6 style={{ fontSize: 18, color: theme.textMuted }}>Vulnerability</h6>
                </div>
                <div className="d-flex justify-content-center mt-3">
                  {hasAssets ? (
                    <h1 className="fw-bold display-6 mb-0" style={{ color: theme.labelTextDanger }}>
                      {score}
                    </h1>
                  ) : (
                    <p className="small px-2" style={{ color: theme.textMuted }}>
                      Start scanning for critical vulnerabilities.
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Slide 2: Critical Misconfigurations */}
            <div>
              <div className="card-body text-center">
                <div className="mb-2">
                  <h4 className="fw-bold" style={{ fontSize: 28, color: theme.labelTextDanger }}>
                    Critical
                  </h4>
                  <h6 style={{ fontSize: 18, color: theme.textMuted }}>Misconfiguration</h6>
                </div>
                <div className="d-flex justify-content-center mt-3">
                  {hasMisconfig ? (
                    <h1 className="fw-bold display-6 mb-0" style={{ color: theme.labelTextDanger }}>
                      {cloudCriticalScore}
                    </h1>
                  ) : (
                    <p className="small px-2" style={{ color: theme.textMuted }}>
                      Start scanning for critical misconfigurations.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
      <style>
        {`
          .critical-vul-mis .slick-dots {
            margin-bottom: 12px;
            position: absolute;
          }
        `}
      </style>
    </>
  );
};

export default CVulMisCarousel;